import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import ProtectedRoute from "./ProtectedRoute";
import AdminRoute from "./AdminRoute";
import ApiKeysPage from "../Pages/ApiKeysPage/ApiKeysPage";
import EmbedPage from "../Pages/EmbedPage/EmbedPage";
import MembersPage from "../Pages/MembersPage/MembersPage";
import ProfilePage from "../Pages/ProfilePage/ProfilePage";
import DocumentationPage from "../Pages/DocumentationPage/DocumentationPage";
import LoginPage from "../Pages/AuthenticationPage/LoginPage";
import RegisterPage from "../Pages/AuthenticationPage/RegisterPage";
import RegisterPremiumPage from "../Pages/AuthenticationPage/RegisterPremiumPage";
import ResetPasswordPage from "../Pages/AuthenticationPage/ResetPasswordPage";
import NewPasswordPage from "../Pages/AuthenticationPage/NewPasswordPage";
import AcceptInvitePage from "../Pages/AuthenticationPage/AcceptInvite";
import ProjectContextProvider from "../context/useProjectContext";
import KeysContextProvider from "../context/useKeysContext";
import MembersContextProvider from "../context/useMembersContext";
import VideoContextProvider from "../context/useVideoContext";
import PresentationContextProvider from "../context/usePresentationContext";
import ProjectPage from "../Pages/ProjectPage/ProjectPage";
import UsersPage from "../Pages/UsersPage/UsersPage";
import SubscriptionsPage from "../Pages/SubscriptionsPage/SubscriptionsPage";
import LicensingContextProvider from "../context/useLicensingContext";
import UsagePage from "../Pages/UsagePage/UsagePage";
import UserConfirmedPage from "../Pages/UserConfirmedPage/UserConfirmedPage";
import DashboardPage from "../Pages/DashboardPage/DashboardPage";
import GlossaryPage from "../Pages/GlossaryPage/GlossaryPage";
import PresentationsPage from "../Pages/PresentationsPage/PresentationsPage";
import SSOAuthSuccessPage from "../Pages/AuthenticationPage/SSOAuthSuccessPage";
import OTPVerificationPage from "../Pages/AuthenticationPage/OTPVerificationPage";
import RealtimeApiKeysPage from "../Pages/ApiKeysPage/RealtimeApiKeysPage";
import VideoApiKeysPage from "../Pages/ApiKeysPage/VideoApiKeysPage";
import ProductApiKeysPage from "../Pages/ApiKeysPage/ProductApiKeysPage";
import WebhooksSection from "../Components/ApiKeyPage/WebhooksSection";
import VideoTranslationPage from "../Pages/VideoTranslationPage/VideoTranslationPage";
import ConferencesPage from "../Pages/ConferencesPage/ConferencesPage";
import EmotiiForTeamsPage from "../Pages/EmotiiForTeamsPage/EmotiiForTeamsPage";

export const router = createBrowserRouter([
  {
    index: "*",
    element: (
      <ProtectedRoute>
        <ProjectContextProvider>
          <KeysContextProvider>
            <MembersContextProvider>
              <LicensingContextProvider>
                <VideoContextProvider>
                  <PresentationContextProvider>
                      <App/>
                  </PresentationContextProvider>
                </VideoContextProvider>
              </LicensingContextProvider>
            </MembersContextProvider>
          </KeysContextProvider>
        </ProjectContextProvider>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/api-keys",
        element: <ApiKeysPage />,
      },
      {
        path: "/realtime-api",
        element: <RealtimeApiKeysPage />,
      },
      {
        path: "/video-api",
        element: <VideoApiKeysPage />,
      },
      {
        path: "/meetings-api",
        element: (
          <ProductApiKeysPage
            productSlug="meetings_api"
            title="API for Meetings"
            keyLabel="API for Meetings key"
            addKeySubtitle="Generate a key to start creating meetings from your own systems."
            keyNamePlaceholder="e.g. CRM Integration"
            infoText="API for Meetings keys let your CRM, ERP or scheduling system create and manage emotii meetings. Generate a key to get started. You can manage and revoke keys whenever needed."
            usageColumns={[
              { key: "words", label: "Words", sortable: true },
              { key: "audio_minutes", label: "Audio Minutes", decimals: 1 },
              { key: "video_minutes", label: "Video Minutes", decimals: 1 },
            ]}
            showLastUsed
            docsProductType="meetings_api"
            showInfoBanner={false}
          >
            <WebhooksSection />
          </ProductApiKeysPage>
        ),
      },
      {
        path: "/glossary",
        element: <GlossaryPage />,
      },
      {
        path: "/video-translation",
        element: <VideoTranslationPage/>,
      },
      {
        path: "/emotii-embed",
        element: <EmbedPage />,
      },
      {
        path: "/profile",
        element: <ProfilePage />,
      },
      {
        path: "/project",
        element: <ProjectPage />,
      },
      {
        path: "/meetings",
        element: <UsersPage />
      },
      {
        path: "/usage",
        element: <UsagePage />,
      },
      {
        path: "/subscriptions",
        element: (
          <AdminRoute>
            <SubscriptionsPage />
          </AdminRoute>
        ),
      },
      {
        path: "/presentations",
        element: <PresentationsPage />
      },
      {
        path: "/conferences",
        element: <ConferencesPage />
      },
      {
        path: "/emotii-for-teams",
        element: <EmotiiForTeamsPage />
      },
    ],
  },

  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/register-enterprise",
    element: <RegisterPremiumPage />,
  },
  {
    path: "/accept-invite",
    element: <AcceptInvitePage />,
  },
  {
    path: "/reset_password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/new-password",
    element: <NewPasswordPage />,
  },
  {
    path: "/user-confirmed",
    element: <UserConfirmedPage />,
  },
  {
    path: "/otp-verification",
    element: <OTPVerificationPage />,
  },
  {
    path: "/sso-authentication",
    element: (
      <ProjectContextProvider>
        <LicensingContextProvider>
          <SSOAuthSuccessPage />
        </LicensingContextProvider>
      </ProjectContextProvider>
    ),
  },
]);
